module.exports = require("react-overlays/lib/RootCloseWrapper");